import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import './output.css';
import App from './App';
import Login from './components/login/Login';
import Admin from './components/admin/Admin';
import List from './components/admin/List';
import reportWebVitals from './reportWebVitals';
import UserProvider from './providers/UserProvider';

ReactDOM.render(
    <React.StrictMode>
        <Router>
            <UserProvider>
                <Routes>
                    <Route path="/" element={<Login />} />
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/previsualizar/:productId"
                        element={<App title="Stickapp" />}
                    />
                    <Route
                        path="/admin/list/"
                        element={<List title="Lista de diseños - Stickapp" />}
                    />
                    <Route
                        path="/admin/list/:page"
                        element={<List title="Lista de diseños - Stickapp" />}
                    />
                    <Route
                        path="/admin/create"
                        element={<Admin title="Crear nuevo diseño - Stickapp" />}
                    />
                    <Route
                        path="/admin/:designId"
                        element={<Admin title="Editar diseño - Stickapp" />}
                    />
                </Routes>
            </UserProvider>
        </Router>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
